import { trackFilterChange } from '../utils/tracking/searchBrowse/filterTracking';

export const ADD_AND_APPLY_FILTER = 'ADD_AND_APPLY_FILTER';
export function addAndApplyFilter(filterName, filterValue, isFromTypeahead = false) {
    trackFilterChange({ filterName, filterValue, isFromTypeahead });
    return {
        type: ADD_AND_APPLY_FILTER,
        payload: { filterName, filterValue, isFromTypeahead },
    };
}

export const REMOVE_AND_APPLY_FILTER = 'REMOVE_AND_APPLY_FILTER';
export function removeAndApplyFilter(filterName, filterValue) {
    trackFilterChange({ filterName, filterValue, isDeselected: true });
    return { type: REMOVE_AND_APPLY_FILTER, payload: { filterName, filterValue } };
}

export const TOGGLE_FILTER_DISPLAY = 'TOGGLE_FILTER_DISPLAY';
export function toggleFilterDisplay(shown) {
    return { type: TOGGLE_FILTER_DISPLAY, filtersShown: shown };
}

export const CLEAR_FILTERS_BY_NAME = 'CLEAR_FILTERS_BY_NAME';
export function clearFiltersByName(filterName) {
    return { type: CLEAR_FILTERS_BY_NAME, payload: filterName };
}

export const ADD_APPLIED_FILTERS = 'ADD_APPLIED_FILTERS';
export function addAppliedFilters(payload) {
    return { type: ADD_APPLIED_FILTERS, payload };
}

export const TOGGLE_REQUEST_IN_FLIGHT = 'TOGGLE_REQUEST_IN_FLIGHT';
export function toggleRequestInFlight(payload) {
    return { type: TOGGLE_REQUEST_IN_FLIGHT, payload };
}

export const UPDATE_URI_REF = 'UPDATE_URI_REF';
export function updateUriRef(uriRef) {
    return { type: UPDATE_URI_REF, payload: uriRef };
}
